module.exports = __webpack_public_path__ + "img/15.5f8c9460.jpg";